import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import TwentyFourHoursToLive from "@/pages/TwentyFourHoursToLive";
import ComplexMNNKBro from "@/pages/ComplexMNNKBro";
import ComplexWorld from "@/pages/ComplexWorld";
import FirstWeFeast from "@/pages/FirstWeFeast";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/portfolio" element={<Home />} />
        <Route path="/24-hours-to-live" element={<TwentyFourHoursToLive />} />
        <Route path="/complex-mnnk-bro" element={<ComplexMNNKBro />} />
        <Route path="/complex-world" element={<ComplexWorld />} />
        <Route path="/first-we-feast" element={<FirstWeFeast />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
